import DefaultProfile from "../../images/v2/Profiles.svg";
import ProBadge from "./ProBadge";
import { useAppConfig } from "@/appConfig";
import { getAgentProfileCardBLSInfo } from "../../helpers/v2/wantAdDetailMeta";

const AgentProfileCard = ({
  isAgentCreated,
  userAvatar,
  userFirstName,
  userLastName,
  userCompany,
  blsReference,
  publishedOn,
  createdOn,
  showAvatar = true,
  showCompany = true,
  showProBadge = true,
  isAgentPremium = false,
  namePrefix = "",
  companySuffix = "",
  avatarSize = "35px",
  avatarWrapperClassName = "property-agent-profile-wrap",
  avatarClassName = "property-agent-profile",
  onAvatarClick,
  linkComponent,
  fallback,
}) => {
  const { tenant } = useAppConfig() || {};
  const { showBLSInfo, blsInfoLine } = getAgentProfileCardBLSInfo(
    { blsReference, publishedOn, createdOn },
    tenant,
  );

  if (!isAgentCreated) {
    return fallback || null;
  }

  return (
    <>
      {showAvatar && (
        <div className={avatarWrapperClassName}>
          <img
            src={userAvatar || DefaultProfile}
            alt="avatar"
            className={`${avatarClassName}${onAvatarClick ? " pe-auto" : ""}`}
            width={avatarSize}
            height={avatarSize}
            {...(onAvatarClick && { role: "button", onClick: onAvatarClick })}
          />
        </div>
      )}
      <div className="property-agent-details">
        <div className="property-agent-name">
          {namePrefix}{userFirstName} {userLastName}
          {showProBadge && <ProBadge isAgentPremium={isAgentPremium} />}
        </div>
        {showBLSInfo ? (
          <div className="property-agent-requested-infoo">
            {blsInfoLine}
            {linkComponent}
          </div>
        ) : (
          showCompany && (
            <div className="property-agent-requested-infoo">
              {String(userCompany || "").trim() ? `Agent @ ${userCompany}${companySuffix}` : "Agent"}
              {linkComponent}
            </div>
          )
        )}
      </div>
    </>
  );
};

export default AgentProfileCard;
